module.exports = __webpack_public_path__ + "img/1567725264.b9272812.jpg";